// import { Box, Button, IconButton, Typography } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import React from "react";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

// const FinancialRecords = () => {
//   const navigate = useNavigate();
//   return (
//     <>
//       <div style={{ width: "100%" }}>
//         <Box
//           sx={{
//             display: "flex",
//             padding: 1,
//             justifyContent: "space-between",
//             alignItems: "center",
//             background: "linear-gradient(to right, #33001b, #ff0084)",
//           }}
//         >
//           <Box onClick={() => navigate(-1)} style={{ textDecoration: "none" }}>
//             <ChevronLeftIcon
//               fontSize="medium"
//               style={{
//                 // width: "60px",
//                 color: "#fff",
//                 border: "1px solid #f2f3f5",
//                 borderRadius: 50,
//               }}
//             />
//           </Box>
//           <Typography variant="subtitle2" color="#fff">
//           Withdrawal Record
//           </Typography>
//           <Box> </Box>
//         </Box>



//         <Box
//           style={{ display: "flex", flexDirection: "column", marginTop: "5px" }}
//         >
//           {[1, 2, 3, 4, 5, 6].map((data, ind) => (
//             <Box
//               sx={{
//                 width: "90%",
//                 margin: "5px 20px",
//                 // position: "relative",
//                 // top: "-3rem",
//                 borderRadius: "12px",
//                 backgroundColor: "#fff",
//               }}
//             >
//               <Box
//                 //   onClick={() => handleNavigation("/redenvelopes")}
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   padding: "10px",
//                 }}
//               >
//                 <Box
//                   style={{
//                     paddingLeft: "10px",
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     gap: 6,
//                   }}
//                 >
//                   <Box
//                     style={{
//                       background: "red",
//                       padding: "10px 15px",
//                       borderRadius: "10px",
//                     }}
//                   >
//                     <Typography color="#fff">R</Typography>
//                   </Box>

//                   <Typography style={{ fontSize: "12px" }}>
//                     2025-01-28 13:03:05
//                   </Typography>
//                 </Box>
//                 <Box>
//                   {/* <Box > */}
//                   <Typography color="#333" fontSize={20} fontWeight={700}>
//                     2100
//                   </Typography>
//                   {/* </Box> */}

//                   <Typography color="#333" style={{ fontSize: "14px" }}>
//                     Under Review
//                   </Typography>
//                 </Box>
//               </Box>
//             </Box>
//           ))}
//         </Box>
//         {/* <Box style={{ marginTop: "60px" }}>
//           <FooterNav />
//         </Box> */}
//       </div>
//     </>
//   );
// };
// export default FinancialRecords;


import { Box, Typography } from "@mui/material";
// import FooterNav from "../FooterNav";
import {useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import axiosInstance from "../AxiosBaseApi";
import Recordlist from "./Wallet/Component/Recordlist";
import Loader from "./Loader";


const FinancialRecords = () => {
  const navigate = useNavigate();

  const [data, SetData] = useState("");
  const [loading, setLoading] = useState(true);

  // console.log(data)
  const getUserData = async (uid) => {
    try {
      const response = await axiosInstance
        .get(`/bet.php?action=withdrawrecord&user=${uid}&page1=1`)

        .then((res) => {
          if (res.status === 200) {
            SetData(res.data);
            setLoading(false);
          } else {
            alert(res.data.message);
          }
        });
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("mamberId");
    if (!token) {
      navigate("/login");
    } else {
      getUserData(token);
    }
  }, []);
  
  return (
    <>
      <div style={{ width: "100%", }}>
        <Box
          sx={{
            display: "flex",
            padding: 1,
            justifyContent: "space-between",
            alignItems: "center",
            background: "#3d3b6f",
          }}
        >
          <Box onClick={() => navigate(-1)} style={{ textDecoration: "none" }}>
            <ChevronLeftIcon
              fontSize="medium"
              style={{
                // width: "60px",
                color: "#fff",
                border: "1px solid #f2f3f5",
                borderRadius: 50,
              }}
            />
          </Box>
          <Typography variant="subtitle2" color="#fff">
            Withdrawal Record
          </Typography>
          <Box> </Box>
        </Box>

        {loading ? (
        <Loader /> // Show the loader when loading is true
      ) : (
        <Recordlist
          data={data}
          text="Withdrawal"
          bgcolor="#34be8a"
          type="Amount"
          by="Account"
           no="IFSC"
        />)}
        {/* <Box style={{ marginTop: "60px" }}>
          <FooterNav />
        </Box> */}
      </div>
    </>
  );
};
export default FinancialRecords;
